export class Additive {
  public name: string;
  public id: number;

  constructor(name: string, id: number) {
    this.name = name;
    this.id = id;
  }


}

export class Additives {
  /**
   * TODO I find this oddly satisfying to be honest but it looks like crap EDIT: and actually is crap.
   * TODO REFACTOR ME PLEASEEEE
   * @param num
   * @returns {Additive}
   */
  static nameByNumber(num:number){
    const additives = [
      (number) => new Additive("Stabilisator", number),
      (number) => new Additive("Säuerungsmittel", number),
      (number) => new Additive("Emulgator", number),
      (number) => new Additive("Antioxidationsmittel", number),
      (number) => new Additive("Geschmacksverstärker", number),
      (number) => new Additive("Farbstoffe", number),
      (number) => new Additive("Gelier- und Verdickungen", number),
      (number) => new Additive("geschwärzt", number),
      (number) => new Additive("koffeinhaltig", number),
    ];
    const additive = additives[num - 1]

    if (additive){ return additive(num) };
    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/additives.ts